module.exports = __webpack_public_path__ + "static/media/schiphol-icons.a5475632.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icons/schiphol-icons.woff
// module id = 649
// module chunks = 0